import type { ApplicationStatus } from '@core/types';

/** Full pipeline enum order used for filters, aggregates, and Kanban buckets. */
export const ALL_STATUSES: ApplicationStatus[] = [
  'submitted',
  'viewed_by_client',
  'shortlisted',
  'interview_1_scheduled',
  'interview_1_conducted',
  'interview_2_scheduled',
  'interview_2_conducted',
  'offer_extended',
  'offer_accepted',
  'offer_rejected',
  'placed',
  'rejected',
  'no_show',
  'on_hold',
  'closed',
];

export const PIPELINE_STATUS_LABEL: Record<ApplicationStatus, string> = {
  submitted: 'Submitted',
  viewed_by_client: 'Viewed',
  shortlisted: 'Shortlisted',
  interview_1_scheduled: 'Int. 1 Sched',
  interview_1_conducted: 'Int. 1 Done',
  interview_2_scheduled: 'Int. 2 Sched',
  interview_2_conducted: 'Int. 2 Done',
  offer_extended: 'Offer',
  offer_accepted: 'Accepted',
  offer_rejected: 'Rejected',
  placed: 'Placed',
  rejected: 'Rejected',
  no_show: 'No Show',
  on_hold: 'On Hold',
  closed: 'Closed',
};

const STATUS_SET = new Set<ApplicationStatus>(ALL_STATUSES);

/**
 * Parse org.pipeline_stage_order (JSON array of status strings).
 * Returns null if empty/invalid; otherwise full list with any missing stages appended.
 */
export function parseOrgPipelineOrder(raw: unknown): ApplicationStatus[] | null {
  if (!Array.isArray(raw) || raw.length === 0) return null;
  const ordered: ApplicationStatus[] = [];
  for (const x of raw) {
    if (typeof x === 'string' && STATUS_SET.has(x as ApplicationStatus)) {
      const s = x as ApplicationStatus;
      if (!ordered.includes(s)) ordered.push(s);
    }
  }
  if (ordered.length === 0) return null;
  for (const s of ALL_STATUSES) {
    if (!ordered.includes(s)) ordered.push(s);
  }
  return ordered;
}

export function buildKanbanColumns(order: ApplicationStatus[]) {
  return order.map((id) => ({ id, label: PIPELINE_STATUS_LABEL[id] }));
}
